import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

import posthog from "posthog-js"

import "../styles/index.scss"

// 2. Load Tailwind second (so it can override the above)
import "../styles/tailwind.css"

// Import all javascript files from src/_components
const componentsContext = require.context("bridgetownComponents", true, /.js$/)
componentsContext.keys().forEach(componentsContext)

// Setup Stimulus
const application = Application.start()
const context = require.context("./controllers", true, /\.js$/)
application.load(definitionsFromContext(context))

// Configure PostHog — only the basics: pageviews + manual identify().
// Everything else (autocapture, session recording, surveys, heatmaps,
// dead clicks, pageleave, exceptions, console logs) is off so we can
// opt back in deliberately later. cross_subdomain_cookie shares the
// anonymous distinct_id across `*.apollo.fyi`, so this user maps to
// the same person on `app.apollo.fyi` and the new marketing site.
if (window.__POSTHOG__ && window.__POSTHOG__.api_key) {
  posthog.init(window.__POSTHOG__.api_key, {
    api_host: window.__POSTHOG__.host || "https://us.i.posthog.com",
    autocapture: false,
    capture_dead_clicks: false,
    capture_exceptions: false,
    capture_heatmaps: false,
    capture_pageleave: false,
    disable_session_recording: true,
    disable_surveys: true,
    enable_recording_console_log: false,
    person_profiles: "identified_only",
    cross_subdomain_cookie: true,
    persistence: "localStorage+cookie",
  })

  // Generic click tracker — any element (or ancestor of a click target)
  // with `data-track-event="…"` fires that PostHog event. Every other
  // `data-track-{key}` attribute on the same element becomes a property
  // (dashes → underscores). Adding a new dimension is a one-line HTML
  // change.
  document.addEventListener("click", (event) => {
    const target =
      event.target && event.target.closest
        ? event.target.closest("[data-track-event]")
        : null
    if (!target) return
    const name = target.dataset.trackEvent
    if (!name) return
    const properties = {}
    for (const attr of target.attributes) {
      if (
        attr.name.startsWith("data-track-") &&
        attr.name !== "data-track-event"
      ) {
        const key = attr.name.slice("data-track-".length).replace(/-/g, "_")
        properties[key] = attr.value
      }
    }
    posthog.capture(name, properties)
  })

  window.posthog = posthog
}

console.info("Bridgetown is loaded!")
